module.exports = __webpack_public_path__ + "static/media/artes.6ae55ebc.svg";